import api from "./api";

// Domini pubblici brandizzati (Guest / Tax) configurabili da Impostazioni.
// COMPORTAMENTO: i link pubblici usano il dominio brandizzato SOLO quando il DNS è attivo
// (dominio raggiungibile e puntato all'app). Finché il DNS non è attivo → fallback automatico
// al dominio corrente, così non si generano mai QR/link non raggiungibili.
let _cache = null;
let _promise = null;

const _clean = (u) => (u || "").replace(/\/+$/, "");

async function _statusOf(domain) {
  if (!domain) return "";
  try {
    const r = await api.get(`/config/domain-status?domain=${encodeURIComponent(domain)}`);
    return r.data?.status || "";
  } catch {
    return "";
  }
}

export async function loadPublicDomains() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = (async () => {
      let d = {};
      try { d = (await api.get("/config/public-domains")).data || {}; } catch { d = {}; }
      const [gs, ts] = await Promise.all([_statusOf(d.guest_domain), _statusOf(d.tax_domain)]);
      _cache = {
        ...d,
        guest_status: gs, tax_status: ts,
        guest_active: gs === "active",
        tax_active: ts === "active",
      };
      return _cache;
    })();
  }
  return _promise;
}

// Invalida la cache (dopo salvataggio impostazioni)
export function resetPublicDomains() { _cache = null; _promise = null; }

// Base effettiva usata per costruire i link pubblici: dominio brandizzato solo se DNS attivo.
export function guestBase(domains) {
  return _clean((domains && domains.guest_active && domains.guest_domain) || window.location.origin);
}
export function taxBase(domains) {
  return _clean((domains && domains.tax_active && domains.tax_domain) || window.location.origin);
}
